import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimerService } from '../services/timer.service';

@Component({
  selector: 'app-timer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit, OnDestroy {
  private readonly timerService = inject(TimerService);

  public readonly timer = this.timerService.getTimerSignal();
  public readonly timeDisplay = this.timerService.getTimeDisplaySignal();
  public readonly isActive = this.timerService.getIsActiveSignal();
  public readonly animationTrigger = this.timerService.getAnimationTriggerSignal();

  ngOnInit(): void {
    this.timerService.startPolling();
  }

  ngOnDestroy(): void {
    this.timerService.stopPolling();
  }
}
